import { EmployeeModel, HiringStateEnum, RefereeModel } from "@shared/models";
import { Employee, EmployeeBasic } from "@shared/factories";
import { FormatDatesService      } from "@shared/services";

export class Referee {
  id:                number;
  createdAt:         Date;

  archivedAt:        Date;
  archivedBy:        EmployeeBasic;

  referrer:          EmployeeBasic;
  referee:           Employee;

  refereeVerifiedAt: Date;
  hiringState:       HiringStateEnum;
  jetIdentifier:     string;
  constructor(data: RefereeModel) {
    this.id                     = data.id                           ? data.id                                           : null;
    this.createdAt              = FormatDatesService.parseDate(data.created_at);

    this.archivedAt             = FormatDatesService.parseDate(data.archived_at);
    this.archivedBy             = data.archived_by                  ? new EmployeeBasic(data.archived_by)               : null;

    this.referrer               = data.referrer                     ? new EmployeeBasic(data.referrer)                  : null;
    this.referee                = data.first_name && data.last_name ? new Employee(this.collectBasicEmployeeData(data)) : null;

    this.refereeVerifiedAt      = FormatDatesService.parseDate(data.referee_verified_at);
    this.hiringState            = data.hiring_state                 ? data.hiring_state                                 : null;
    this.jetIdentifier          = data.jet_identifier               ? data.jet_identifier                               : null;
  }

  private collectBasicEmployeeData(data: RefereeModel): EmployeeModel {
    return {
      id:           data.id,
      first_name:   data.first_name,
      last_name:    data.last_name,
      email:        data.email,
      phone_number: data.mobile_phone,
    };
  }

  toJSON(): RefereeModel {
    return {
      id:                  this.id            ? this.id                      : null,
      referrer_id:         this.referee       ? this.referee.id              : null,
      created_at:          FormatDatesService.parseDateISO(this.createdAt),

      archived_at:         FormatDatesService.parseDateISO(this.archivedAt),
      archived_by:         this.archivedBy    ? this.archivedBy.toJSON()     : null,

      referrer:            this.referrer      ? this.referrer.toJSON()       : null,

      first_name:          this.referee       ? this.referee.first_name      : null,
      last_name:           this.referee       ? this.referee.last_name       : null,

      mobile_phone:        this.referee       ? this.referee.phone_number    : null,
      email:               this.referee       ? this.referee.email           : null,

      hiring_state:        this.hiringState   ? this.hiringState             : null,
      jet_identifier:      this.jetIdentifier ? this.jetIdentifier           : null,

      referee_verified_at: FormatDatesService.parseDateISO(this.refereeVerifiedAt),
    };
  }

}
